// https://github.com/jupyter/notebook/blob/master/notebook/services/contents/manager.py#L40
export abstract class ContentsManager {
  abstract async get(
    path: string,
    type: string,
    format: string | null,
    content: number
  ): Promise<any>;
  abstract fileExists(path: string): Promise<boolean>;
  abstract save(model: {}, path: string): Promise<any>;
}
